
export const name = "crm-tasks-ui";
export const version = "dev";
